var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_3189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66671 3.33334H7.95631C9.9878 3.33334 11.0036 3.33334 11.3891 3.6982C11.7224 4.01359 11.8701 4.4782 11.7802 4.92815C11.676 5.44869 10.8468 6.03525 9.18823 7.20836L6.47852 9.12499C4.81998 10.2981 3.9907 10.8847 3.8866 11.4052C3.79661 11.8552 3.94432 12.3198 4.27762 12.6352C4.6632 13 5.67895 13 7.71044 13H8.33337M5.33337 3.33334C5.33337 4.43791 4.43794 5.33334 3.33337 5.33334C2.2288 5.33334 1.33337 4.43791 1.33337 3.33334C1.33337 2.22877 2.2288 1.33334 3.33337 1.33334C4.43794 1.33334 5.33337 2.22877 5.33337 3.33334ZM14.6667 12.6667C14.6667 13.7712 13.7713 14.6667 12.6667 14.6667C11.5621 14.6667 10.6667 13.7712 10.6667 12.6667C10.6667 11.5621 11.5621 10.6667 12.6667 10.6667C13.7713 10.6667 14.6667 11.5621 14.6667 12.6667Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_3189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.3710b3badc539e13d1369761dd88b944.svg";
export { ForwardRef as ReactComponent };